import React from 'react';
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import CircularProgress from '@material-ui/core/CircularProgress';
import {Link} from 'react-router-dom';
import IntlMessages from 'util/IntlMessages';
import queryString from 'query-string';
import SweetAlert from 'react-bootstrap-sweetalert';

import {
    hideMessage,
    showAuthLoader,
    userFacebookSignIn,
    userGithubSignIn,
    userGoogleSignIn,
    userSignUp,
    userTwitterSignIn
} from 'actions/B2Auth';

import {
    ACTIVATE_ACCOUNT,
    CLOSE_B2_MESSAGE
} from 'constants/B2ActionTypes';

import {
    RESEND_ACTIVE_LINK
} from 'constants/SafeeActionTypes';

import {
    processB2SecurityEvent
} from 'actions/B2App';

class Activate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            verificationEmailResent: null
        }
    }

    resendActivationLink = () => {
        const b2SecEvent = {
            type: RESEND_ACTIVE_LINK,
            callback: this.showVerificationEmailResent.bind(this),
            eventDetails: {
                token: queryString.parse(this.props.location.search)['token']
            }
        }

        this.props.processB2SecurityEvent(b2SecEvent);
    }

    showVerificationEmailResent(eventResponse){

        if (eventResponse && eventResponse.infos && eventResponse.infos.length > 0){
            this.setState(
                {
                    ...this.state,
                    verificationEmailResent: true,
                }
            );
        }
    }

    isMobile = () => {
        let check = false;

        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);

        return check;
    }

    isDriver = () => {
        if (this.props.groups && this.props.groups.data && this.props.groups.data.length > 0){
            let driversGroup = this.props.groups.data.find((element) => {
                            return element.attributes.groupName &&
                                element.attributes.groupName.value &&
                                element.attributes.groupName.value !== null &&
                                typeof element.attributes.groupName.value != 'undefined' &&
                                element.attributes.groupName.value.toLowerCase() === 'drivers';
                          });

            if (driversGroup){
                return true;
            }
        }

        return false;
    }

    navigateToApp = () => {
        window.location.href="au.com.safee.0478900144://au.com.safee.0478900144";
    }

    navigateToSubscription = () => {
        let url = '/app/b2/subscription'
//        if (this.props.accessibleApps && this.props.accessibleApps.length > 0){
//            let accessibleHomeApp = this.props.accessibleApps.find((element) => {
//                return element.attributes.appName &&
//                    element.attributes.appName.value &&
//                    element.attributes.appName.value !== null &&
//                    typeof element.attributes.appName.value != 'undefined' &&
//                    element.attributes.appName.value.toLowerCase() === 'home';
//              });
//
//            if (!accessibleHomeApp){
//                if (this.props.defaultApp){
//                    url =  '/app/b2/' + this.props.defaultApp.toLowerCase();
//                }else if (this.props.dashboards && this.props.dashboards.length > 0 ){
//                    let defaultDashboard = this.props.dashboards.find((element) => {
//                        return element.attributes.elementType &&
//                            element.attributes.elementType.value === 'APP' &&
//                            element.attributes.menuType &&
//                            element.attributes.menuType.value === 'DASHBOARD' &&
//                            element.attributes.appName &&
//                            element.attributes.appName.value &&
//                            element.attributes.appName.value !== null &&
//                            typeof element.attributes.appName.value != 'undefined' &&
//                            element.attributes.appName.value.toLowerCase() != 'home';
//                      });
//                    if (defaultDashboard){
//                        url =  '/app/b2/' + defaultDashboard.attributes.appName.value.toLowerCase();
//                    }else{
//                        url =  '/app/b2/' + this.props.dashboards[0].attributes.appName.value.toLowerCase();
//                    }
//                }
//            }
//        }

        window.location.href=url;
    }

    navigateToRecordKeeperDashboard = () => {
        let url = '/'

        window.location.href=url;
    }

    render() {
        return (
            <React.Fragment>

                <div className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                    <div className="app-login-main-content">
                        <div className="app-logo-content d-flex align-items-center justify-content-center">
                            <Link className="logo-lg" to="/" title="Safee">
                                <img src={require("assets/images/safee_logo_square.png")}  alt="Safee" title="Safee"/>
                            </Link>
                        </div>

                        <div className="app-login-content">
                            <div className="app-login-header">
                                <h1>
                                    {
                                        this.props.b2Message?
                                        (
                                            (this.props.b2Message.type==='error' && this.props.b2Message.code==='500083')?
                                                'Verification link expired'
                                                :
                                                this.props.b2Message.message
                                        )
                                        :
                                        'Verifying email address, Please wait...'
                                    }
                                </h1>
                            </div>

                            <div className="align-items-center app-login-form">
                                <form method="post" action="/">
                                    <div className="mb-3 d-flex align-items-center justify-content-between">
                                        {
//                                            !this.state.verificationEmailResent && this.isMobile() && this.isDriver() && this.props.b2Message && this.props.b2Message.type==='info' &&
//                                            <Button variant="contained" onClick={this.navigateToApp.bind(this)} color="primary">
//                                                <IntlMessages id="safee.returnToApp"/>
//                                            </Button>
                                        }

                                        {
                                            !this.state.verificationEmailResent && this.isDriver() && this.props.b2Message && this.props.b2Message.type==='info' &&
                                            <Button variant="contained" onClick={this.navigateToSubscription.bind(this)} color="primary">
                                                <IntlMessages id="safee.proceedToSubscriptionOptions"/>
                                            </Button>
                                        }

                                        {
                                            !this.state.verificationEmailResent && !this.isDriver() && this.props.b2Message && this.props.b2Message.type==='info' &&
                                            <Button variant="contained" onClick={this.navigateToRecordKeeperDashboard.bind(this)} color="primary">
                                                <IntlMessages id="safee.proceedToDashboard"/>
                                            </Button>
                                        }

                                        {
                                            !this.state.verificationEmailResent && this.props.b2Message && this.props.b2Message.type==='error' && this.props.b2Message.code==='500083' &&
                                                <Button variant="contained"
                                                    onClick={
                                                        ()=>{this.resendActivationLink()}
                                                    } color="primary">
                                                    Click to send a New Verification Email
                                                </Button>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {
                        this.props.loginLoader &&
                        <div className="loader-view">
                            <CircularProgress/>
                        </div>
                    }

                </div>
                </React.Fragment>
            );
    }
}

const mapStateToProps = ({b2State}) => {
    const {user, groups, accessibleApps, dashboards, defaultApp, loginLoader, b2Message} = b2State;
    return {user, groups, accessibleApps, dashboards, defaultApp, loginLoader, b2Message}
};

export default connect(mapStateToProps, {
    processB2SecurityEvent
})(Activate);
